(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('salesBookService',salesBookService);

    salesBookService.$inject = ['$http', 'CONFIG','messageService'];

    function salesBookService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_REPORT + '/' + CONFIG.API + '/salesReports';

        var service = {
            getSalesBook: getSalesBook,
            getSalesBookFreeMarker: getSalesBookFreeMarker
        };

        return service;

        function getSalesBook(economicActivityId, year, month){
            return $http.get(urlBase + '/sales' + '?economicActivityId='+economicActivityId + '&year=' + year + '&month=' + month, {responseType:'arraybuffer'})
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function getSalesBookFreeMarker(economicActivityId, year, month) {
            return $http.get(urlBase + '/sales-invoice' + '?economicActivityId='+economicActivityId + '&year=' + year + '&month=' + month)
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

    }
})();
